<mat-sidenav-container class="sidenav-container" autosize id="body">
	<mat-sidenav #sidenav class="sidenav" mode="side" [opened]="openSidenav">
		<mat-nav-list>
			<div>
        <a mat-list-item (click)="focusShowWait(true)">Congestion</a>
				<a mat-list-item (click)="focusHole01(true)">Hole 1</a>
        <a mat-list-item (click)="focusHole02(true)">Hole 2</a>
        <a mat-list-item (click)="focusHole03(true)">Hole 3</a>
        <a mat-list-item (click)="focusHole04(true)">Hole 4</a>
        <a mat-list-item (click)="focusHole05(true)">Hole 5</a>
        <a mat-list-item (click)="focusHole06(true)">Hole 6</a>
        <a mat-list-item (click)="focusHole07(true)">Hole 7</a>
        <a mat-list-item (click)="focusHole08(true)">Hole 8</a>
        <a mat-list-item (click)="focusHole09(true)">Hole 9</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole10(true)">Hole 10</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole11(true)">Hole 11</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole12(true)">Hole 12</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole13(true)">Hole 13</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole14(true)">Hole 14</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole15(true)">Hole 15</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole16(true)">Hole 16</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole17(true)">Hole 17</a>
        <a *ngIf="hole18" mat-list-item (click)="focusHole18(true)">Hole 18</a>
			</div>
		</mat-nav-list>
	</mat-sidenav>
	<div class="sidenav-content">
    <button mat-fab color="primary" type="button" (click) ="toggleNav()" class ="md-fab md-fab-bottom-right">
      <mat-icon *ngIf="!openSidenav">menu</mat-icon>
      <mat-icon *ngIf="openSidenav">close</mat-icon>
    </button>
    <app-wait-time *ngIf="showHoleWait"></app-wait-time>
    <app-hole01 *ngIf="showHole01"></app-hole01>
    <app-hole02 *ngIf="showHole02"></app-hole02>
    <app-hole03 *ngIf="showHole03"></app-hole03>
    <app-hole04 *ngIf="showHole04"></app-hole04>
    <app-hole05 *ngIf="showHole05"></app-hole05>
    <app-hole06 *ngIf="showHole06"></app-hole06>
    <app-hole07 *ngIf="showHole07"></app-hole07>
    <app-hole08 *ngIf="showHole08"></app-hole08>
    <app-hole09 *ngIf="showHole09"></app-hole09>
    <app-hole10 *ngIf="showHole10"></app-hole10>
    <app-hole11 *ngIf="showHole11"></app-hole11>
    <app-hole12 *ngIf="showHole12"></app-hole12>
    <app-hole13 *ngIf="showHole13"></app-hole13>
    <app-hole14 *ngIf="showHole14"></app-hole14>
    <app-hole15 *ngIf="showHole15"></app-hole15>
    <app-hole16 *ngIf="showHole16"></app-hole16>
    <app-hole17 *ngIf="showHole17"></app-hole17>
    <app-hole18 *ngIf="showHole18"></app-hole18>
  </div>
</mat-sidenav-container>
